var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', {
    staticStyle: {
      "height": "calc(100% - 4px)",
      "width": "calc(100% - 8px)"
    },
    attrs: {
      "outlined": true,
      "rounded": "",
      "color": _vm.index === _vm.currentPageNumber ? 'info' : ''
    }
  }, [_c('v-card', {
    staticStyle: {
      "height": "calc(100% - 4px)",
      "width": "calc(100% - 4px)",
      "margin": "2px"
    },
    attrs: {
      "flat": "",
      "outlined": _vm.index === _vm.currentPageNumber
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('setCurrentPage', _vm.index);
      }
    }
  }, [_c('v-img', {
    staticClass: "ma-auto",
    staticStyle: {
      "max-height": "calc(100% - 24px)"
    },
    attrs: {
      "contain": "",
      "src": _vm.page.src
    }
  }), _c('div', {
    staticStyle: {
      "display": "flex",
      "height": "19px",
      "justify-content": "center",
      "justify-items": "center",
      "align-items": "center"
    }
  }, [_c('small', [_vm._v(" " + _vm._s(_vm.$t("sign.DocumentTemplateDetailTokenList.page")) + " " + _vm._s(_vm.index + 1) + " ")]), _c('v-spacer'), _c('tooltip', {
    key: 'signs' + _vm.countSignatureTokens(_vm.index),
    attrs: {
      "text": _vm.$t('sign.DocumentTemplateDetailTokenList.signaturePage')
    }
  }, [_vm.countSignatureTokens(_vm.index) ? _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v(" mdi-signature-freehand ")]) : _vm._e()], 1), _c('tooltip', {
    key: 'missing' + _vm.countMissingTokens(_vm.index),
    attrs: {
      "text": _vm.$t('sign.DocumentTemplateDetailTokenList.missingFields')
    }
  }, [_vm.countMissingTokens(_vm.index) ? _c('v-icon', {
    attrs: {
      "small": "",
      "color": _vm.countMissingRequiredTokens(_vm.index) ? 'error' : ''
    }
  }, [_vm._v(" mdi-alert-box-outline ")]) : _vm._e()], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }